import { connect } from "react-redux";
import Supplier_Payment from "../Components/new_payment/supplierpayment";
import { Settablehistory } from "../Service/Actions/action";

const dispatchpart = (dispatch) => ({
  Settable_history: (data) => dispatch(Settablehistory(data)),
});

const getpart = (state) => ({
  state,
});

export default connect(getpart, dispatchpart)(Supplier_Payment);
